export const SEARCH_QUERY = 'search';
export const IMAGES_ON_PAGE = 28;
export const PAGE_QUERY = 'page';
export const DEFAULT_PAGE = '1';
export const FOLDER_ID_QUERY_PARAM = 'folder';
export const TAB_QUERY_PARAM = 'tab';
export const GALLERY_CACHE_QUERY_KEY = 'galleryImages';
export const FOLDER_CACHE_QUERY_KEY = 'folders';
export const INFINITY_FOLDERS_QUERY_KEY = 'move_to_folder';
export const FILE_CACHE_QUERY_KEY = 'file_by_id';
export const IS_OPEN_FILE_INFO_MODAL_QUERY_PARAM = 'modal_open';
export const FILE_ID_QUERY_PARAM = 'file_id';
